// libs
import momentTZ from 'moment-timezone'
// constants
import { DATE_FORMAT_VALUES } from 'constants/objects'
import { COUNTRY_FORMATS, DATE_FORMATS, NUMBER_EXAMPLE } from 'constants/date'
// utils
import { flatten, groupBy, keys, round, sortBy, uniq } from 'lodash'

export const getDateAndNumberByCountry = (country) => {
  return `${DATE_FORMATS()[country].format(new Date())} ${COUNTRY_FORMATS()[country].format(NUMBER_EXAMPLE)}`
}

export const generateTimezoneOptions = () => {
  const momentOptions = momentTZ.tz.names().map((name) => {
    const offset = round(momentTZ.tz(name).utcOffset() / 60, 1).toString()

    return {
      offset,
      label: name,
      value: name
    }
  })

  const grouped = groupBy(momentOptions, 'offset')

  const options = keys(grouped).map((offset) => {
    const currentGroup = grouped[offset]

    const names = currentGroup.map(({ value }) => value)
    const uniqueZones = uniq(names.map((name) => name.split('/')[0]))

    return uniqueZones
      .filter((zone) => !zone.match(/^Etc$/))
      .map((zone) => {
        const label = names
          .filter((name) => name.includes(`${zone}/`))
          .map((name) => name.replace(`${zone}/`, ''))
          .join(', ')
          .replace(/_/gi, ' ')

        return {
          label: `(GMT ${parseInt(offset, 10) > 0 ? `+${offset}` : offset}): ${zone}: ${label}`,
          offset,
          value: names.find((name) => name.includes(`${zone}/`))
        }
      })
      .filter(({ value }) => !!value)
  })

  return sortBy(flatten(options), ({ offset }) => parseFloat(offset))
}

export const formatActivityDate = (timezone, date) => momentTZ(date).tz(timezone).format('DD/MM/YYYY [at] h:mma zz')

export const trimTz = (value) => value?.format('YYYY-MM-DD')

export const isISODateString = (str) => {
  // Check if the string matches the ISO 8601 format using a regular expression
  const isoDateRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d+)?(?:Z|[+-]\d{2}:\d{2})?$/

  if (isoDateRegex.test(str)) {
    const date = new Date(str)
    return date.toISOString() === str
  }
  return false
}

export const getDefaultDateFormat = (format) => {
  switch (format) {
    case DATE_FORMAT_VALUES.DATE_TIME:
      return 'DD MM YYYY HH:mm'
    case DATE_FORMAT_VALUES.TIME:
      return 'HH:mm'
    default:
      return 'DD MM YYYY'
  }
}
